export default {
	prefix: 'R$ ',
	thousands: '.',
	decimal: ',',
	precision: 2
};
